import { ROLE_WILDCARD_PUBLIC, UnespCoreMenuItem } from '@unesp/core'

export const menu: UnespCoreMenuItem[] = [
  // PUBLICO
  {
    displayName: 'Processo seletivo',
    iconName: 'grading',
    roles: [ROLE_WILDCARD_PUBLIC],
    order: 997,
    children: [
      {
        displayName: 'Aluno regular',
        iconName: 'edit_note',
        roles: [ROLE_WILDCARD_PUBLIC],
        order: 1,
        route: 'processo-seletivo/aluno-regular',
      },
      {
        displayName: 'Aluno especial',
        iconName: 'edit_note',
        roles: [ROLE_WILDCARD_PUBLIC],
        order: 2,
        route: 'processo-seletivo/aluno-especial',
      },
      {
        displayName: 'Login do candidato',
        iconName: 'lock',
        roles: [ROLE_WILDCARD_PUBLIC],
        order: 3,
        route: 'login-candidato',
      },
    ],
  },
  {
    displayName: 'Autenticidade de documento',
    iconName: 'qr_code_scanner',
    roles: [ROLE_WILDCARD_PUBLIC],
    route: 'autenticidade-documento',
    order: 998,
  },
  {
    displayName: 'Voltar ao portal',
    iconName: 'home',
    roles: [ROLE_WILDCARD_PUBLIC],
    route: 'voltar-portal',
    order: 1000,
  },
]
